import { render } from "./CardScroll.vue?vue&type=template&id=1f468c80&scoped=true&lang=pug"
import script from "./CardScroll.vue?vue&type=script&lang=ts"
export * from "./CardScroll.vue?vue&type=script&lang=ts"

import "./CardScroll.vue?vue&type=style&index=0&id=1f468c80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f468c80"

export default script